import Box from '@mui/material/Box';
import { Drawer } from '@mui/material';
import FillFormDrawerContent from 'components/@home/drawers/FillFormDrawer/FillFormDrawerContent';
import Loading from 'components/common/Loading';
import isEqual from 'lodash/isEqual';
import { bool, func, object, string } from 'prop-types';
import React, { memo, useEffect, useState } from 'react';
import CloseButton from '../CloseButton';

import connector from './connector';
import formik from './formik';

const FillFormDrawer = ({ form = { error: false }, formId = null, isOpen, actions, resetForm }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (isOpen && formId && !form.loading && !loaded) {
      actions.forms.find(formId);
      setLoaded(true);
    } else if (!isOpen) {
      setLoaded(false);
      resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- resetForm from parent; omit to avoid reopen loops
  }, [isOpen, form.loading, form.error, formId, actions, loaded]);

  const handleClose = () => {
    actions.drawers.fillForm.close();
    setLoaded(false);
    resetForm();
  };

  return (
    <Drawer anchor="right" open={isOpen} onClose={handleClose}>
      <Box
        sx={theme => ({
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          width: '100%',
          maxWidth: 'calc(100vw - 40px)',
          [theme.breakpoints.up('md')]: {
            width: 1100,
          },
        })}
      >
        <Box sx={{ pt: '20px', pl: '20px' }}>
          <CloseButton onClick={handleClose} />
        </Box>
        <Box sx={{ display: 'flex', flex: 1 }}>
          {!loaded ? <Loading /> : <FillFormDrawerContent />}
        </Box>
      </Box>
    </Drawer>
  );
};

FillFormDrawer.propTypes = {
  form: object,
  actions: object.isRequired,
  isOpen: bool.isRequired,
  resetForm: func.isRequired,
  formId: string,
};

const areEqual = (prev, next) => {
  return ['form', 'isOpen', 'formId', 'message'].reduce(
    (acc, att) => acc && isEqual(prev[att], next[att]),
    true,
  );
};
export default connector(memo(formik(FillFormDrawer), areEqual));
